import React from "react";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <>
      {/* BANNER (footer-top) */}
      <section
        className="footer-top"
        style={{ backgroundImage: "url(/legacy/images/img/nexio-help-back-2-new.webp)" }}
      >
        <div className="container">
          <div className="banner-2-wrapper">
            <div className="row justify-content-center">
              <div className="col-md-10 col-lg-8">
                <div className="banner-2-txt mx-35 text-center color--white">
                  <div className="ftrt-social-media">
                    <ul className="ico-20 text-center">
                      <li>
                        <a href="https://www.facebook.com/websiteseodotae" target="_blank" rel="noreferrer">
                          <span className="flaticon-facebook"></span>
                        </a>
                      </li>
                      <li>
                        <a href="https://x.com/websiteseodotae" target="_blank" rel="noreferrer">
                          <span className="flaticon-twitter"></span>
                        </a>
                      </li>
                      <li>
                        <a href="https://www.linkedin.com/company/websiteseo-ae/" target="_blank" rel="noreferrer">
                          <span className="flaticon-linkedin-sign"></span>
                        </a>
                      </li>
                      <li>
                        <a href="https://www.instagram.com/websiteseo.ae" target="_blank" rel="noreferrer">
                          <span className="flaticon-instagram"></span>
                        </a>
                      </li>
                    </ul>
                  </div>

                  <h2 className="fs-25">Let&apos;s connect to discuss your needs! </h2>

                  <a href="tel:+971555709788" className="btn btn-md r-08 btn--plum hover--tra-white mt-25">
                    Call us 24/7 @ +971 55 570 9788
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="pt-100 footer-2 footer division" style={{ background: "#0f0f0f" }}>
        <div className="container">
          <div className="row footer-links">
            {/* FOOTER INFO */}
            <div className="col-md-12 col-lg-3">
              <div className="fl-3">
                <h6 className="d-title">Domains &amp; Hosting</h6>
                <h6 className="m-title">Domains &amp; Hosting</h6>
                <ul className="foo-links clearfix">
                  <li><Link to="/registering-domain">Registering Domain</Link></li>
                  <li><Link to="/renewal-of-domain">Renewal of Domain</Link></li>
                  <li><Link to="/ae-domain-registration">AE Domain Registration</Link></li>
                  <li><Link to="/transferring-of-domain">Transferring of Domain</Link></li>
                  <li><Link to="/com-domain-registration">.Com Domain Registration</Link></li>
                  <li><Link to="/dedicated-hosting">Dedicated Hosting</Link></li>
                </ul>
              </div>
            </div>

            {/* FOOTER LINKS */}
            <div className="col-md-9 col-lg-7">
              <div className="row footer-links clearfix">
                <div className="col-md-4">
                  <div className="fl-1">
                    <h6 className="d-title">Online Marketing</h6>
                    <h6 className="m-title">Online Marketing</h6>
                    <ul className="foo-links clearfix">
                      <li><Link to="/brand-management">Brand Management</Link></li>
                      <li><Link to="/brand-marketing-strategy">Brand Marketing Strategy</Link></li>
                      <li><Link to="/social-media-marketing">Social Media Marketing</Link></li>
                      <li><Link to="/blog-development">Blog Development</Link></li>
                      <li><Link to="/email-marketing">Email Marketing</Link></li>
                      <li><Link to="/sms-marketing">SMS Marketing</Link></li>
                    </ul>
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="fl-2">
                    <h6 className="d-title">Branding</h6>
                    <h6 className="m-title">Branding</h6>
                    <ul className="foo-links clearfix">
                      <li><Link to="/profile-designing">Profile Designing</Link></li>
                      <li><Link to="/brochure-designing">Brochure Design</Link></li>
                      <li><Link to="/e-brochure">E-Brochure</Link></li>
                      <li><Link to="/business-card-design">Business Card</Link></li>
                      <li><Link to="/corporate-identity">Corporate Identity</Link></li>
                      <li><Link to="/logo-design">Logo Design</Link></li>
                    </ul>
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="fl-3 mb-0">
                    <h6 className="d-title">More Services</h6>
                    <h6 className="m-title">More Services</h6>
                    <ul className="foo-links clearfix">
                      <li><Link to="/banner-ads-management">Banner Ads Management</Link></li>
                      <li><Link to="/personalized-product-catalogs">Customized Product Catalogs</Link></li>
                      <li><Link to="/information-architecture-strategy-planning">Information Architecture</Link></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            {/* FOOTER CONNECT */}
            <div className="col-md-3 col-lg-2">
              <div className="fl-3">
                <h6 className="d-title">Support</h6>
                <h6 className="m-title">Support</h6>
                <ul className="foo-links clearfix">
                  <li><Link to="/contact-us">Contact Us</Link></li>
                  <li><Link to="/about-us">About us</Link></li>
                  <li><Link to="/portfolio">Protfolio</Link></li>
                  <li><Link to="/clients">Clients</Link></li>
                  <li><Link to="/pricing">Pricing</Link></li>
                </ul>
              </div>
            </div>
          </div>

          {/* BOTTOM FOOTER */}
          <div className="bottom-footer">
            <div className="row row-cols-1 row-cols-md-2 d-flex align-items-center">
              <div className="col">
                <div className="footer-copyright">
                  <p className="fs-14">&copy;WebsiteSeo.ae <span>All Rights Reserved</span></p>
                </div>
              </div>
              <div className="col">
                <ul className="bottom-footer-list ico-10 text-end clearfix">
                  <li><p className="fs-14"><Link to="/blog">Latest Blogs</Link></p></li>
                  <li><p className="fs-14"><Link to="/privacy-policy">Privacy Policy</Link></p></li>
                  <li><p className="fs-14"><Link to="/privacy-policy">Terms &amp; Conditions</Link></p></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </footer>

      {/* QUICK CONTACT WIDGET */}
      <div className="quick_contact">
        <a
          href="https://api.whatsapp.com/send?phone=971555709788&text=Hello, I would like to get more information about your services"
          className="qwhtsapp heart-inner"
          target="_blank"
          rel="noreferrer"
        >
          <i className="quick_contact_icon">
            <img src="/legacy/images/img/whatsapp.svg" alt=" whatsapp" />
          </i>
        </a>
        <a href="tel:+971555709788" className="qcall heart-inner" target="_blank" rel="noreferrer">
          <i className="quick_contact_icon">
            <img
              src="/legacy/images/img/call-now.svg"
              width="30px"
              style={{ marginTop: "5px" }}
              alt="best digital marketing company ajman"
            />
          </i>
        </a>
      </div>
    </>
  );
}

export default Footer;
